/**
 * Created by razial on 19.10.2021
 */
cleverapps.SkinManager.SKINS.adventure_expedition_base = {
    slots: {
        ...cleverapps.SkinManager.SKINS.rose_energy.slots,
        energy_icon_png: bundles.buttons_inlined_icons.frames.adventure_energy_icon_png,

        getPerson: function () {
            return "_adventure";
        },

        getWorkingAnimation: function (code) {
            const animations = AdventureExpedition.sourceAnimations.default;
            return animations[code];
        },

        customerInfoViewFont: function () {
            return cleverapps.styles.FONTS.ADVENTURE_CUSTOMER_INGREDIENT_INFOVIEW;
        },

        isometricExplode: function () {
            return true;
        },

        workerCutTime: function () {
            return 550;
        },

        noReceiveWorkerWindow: function () {
            return true;
        },

        walkingWorkersSkins: function () {
            return ["alpha"];
        },

        bonusWorkerWindowSkin: function () {
            return ["alpha", "beta", "gamma"];
        },

        roomToneEffect: function () {
            return "expedition.room.tone";
        },

        showOneIngredientLeft: function () {
            return false;
        },

        customerStayFocused: function () {
            return false;
        },

        fogBlocker: function () {
            return cleverapps.styles.FogLockView.expedition;
        },

        startQuestsEffect: function () {
            return "quests.start.adventure";
        },

        buyFogWindowEffect: function () {
            return "buyfogwindow.show.adventure";
        },

        inc_energy_effect: function () {
            return "merge.energy.inc";
        },

        dec_energy_effect: function () {
            return "merge.energy.use";
        },

        expFlyFinishEffect: function () {
            return false;
        },
        flyToRewardBoxEffect: function () {
            return false;
        },
        skipPrizeViewCreatedEffect: function () {
            return true;
        },
        jumpCollectEffect: function () {
            return "ui.jump.collect.adventure";
        },
        hasGrabInfoView: function () {
            return true;
        },
        unitGroundHighlight: function () {
            return false;
        },
        outlineUnit: function () {
            return true;
        },
        gameSceneBg: function () {
            return {};
        }
    }
};
